export default __webpack_public_path__ + "static/pink-d54a1d7658434e0979741c50639818e0.png";